import React from "react";

import Header from '../header'

const Layout = ({ children }) => (
  <React.Fragment>
    <div className="main-layout d-flex flex-column">
      <Header />
      {children}
    </div>
    <div className="container py-5">
      <div className="row">
        <div className="col">
          <div className="w-auto text-center">© 2019, Mykola Voronin</div>
        </div>
      </div>
    </div>
  </React.Fragment>
);

export default Layout;
